import VentesModuleLayout from "@features/ventes/components/VentesModuleLayout";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ShoppingCart } from "lucide-react";

/**
 * Ventes Module Route
 *
 * Layout wrapper for the Ventes feature.
 * Module-level guard requires at least one ventes permission.
 * Per-feature permission checks are defined in child routes.
 */
export const Route = createFileRoute("/_app/ventes")({
  loader: requirePermission(PERMISSIONS.VENTES.CLIENTS.VIEW, {
    redirectTo: "/unauthorized",
  }),
  staticData: {
    title: "Ventes",
    icon: ShoppingCart,
    permission: PERMISSIONS.VENTES.CLIENTS.VIEW,
    module: "Ventes",
    section: "Ventes",
    order: 25,
    showInNav: false,
  },
  component: VentesModuleLayout,
});
